import React from 'react'
import Img from 'gatsby-image'
import { StaticQuery } from 'gatsby'
import { graphql } from 'gatsby'

import NouilleCSS from './section-nouille.module.css'

const FingerNouille = ({ fullpageApi }) => (
  <StaticQuery
    query={graphql`
      query ImageOneNouille {
        file(
          relativePath: { eq: "projets/Labo/finger/photos/finger-nouille.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1400, quality: 87) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={({ file }) => (
      <div
        className="section"
        onClick={() => fullpageApi.moveSectionDown()}
        onKeyDown={() => fullpageApi.moveSectionDown()}
        role="button"
        tabIndex={0}
        style={{ cursor: 'pointer' }}
      >
        <Img
          imgStyle={{ objectFit: 'contain' }}
          className={NouilleCSS.image}
          fluid={file.childImageSharp.fluid}
        />
      </div>
    )}
  />
)

export default FingerNouille
